import styled from 'styled-components';
import { H1, H2, H3, SectionParent } from '../../components/StyledComponents';

import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import card1 from '../../assets/v2/Pricing/card1.svg';
import card2 from '../../assets/v2/Pricing/card2.svg';
import { navigate } from '@reach/router';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f8fafd;
  padding-top: 7rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 8px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
  background-color: #ffffff;
  padding: 2rem;
  width: 70%;
  margin-bottom: 3rem;
  @media (max-width: 520px) {
    padding: 1rem;
    width: 90%;
  }
`;

const GridLeft = styled.div`
  display: grid;
  grid-column: span 2;
  align-items: center;
  justify-content: center;
  padding-left: 2rem;
  @media (max-width: 520px) {
    grid-column: span 3;
    padding-left: 0;
  }
`;

const GridTitle = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  text-align: left;
  display: grid;
  align-self: end;
  padding-bottom: 1rem;
  @media (max-width: 800px) {
    font-size: 24px;
    text-align: center;
    padding-top: 1rem;
  }
`;

const GridSubTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #5d88be;
  text-align: left;
  display: grid;
  cursor: pointer;
  width: fit-content;
  align-self: start;
  :after {
    content: '';
    display: block;
    width: 0;
    height: 5px;
    border-radius: 8px;
    background: #5d88be;
    transition: width 0.3s;
  }

  :hover::after {
    width: 100%;
    border-radius: 8px;
  }
  @media (max-width: 800px) {
    font-size: 14px;
    text-align: center;
    width: 100%;
    padding-bottom: 1rem;
  }
`;
const GridSubTitleSecond = styled(GridSubTitle)`
  :after {
    content: '';
    display: block;
    width: 0;
    height: 5px;
    border-radius: 8px;
    background: #735dbe;
    transition: width 0.3s;
  }

  :hover::after {
    width: 100%;
    border-radius: 8px;
  }
`;
const GridRight = styled.div`
  display: grid;
  grid-column: span 1;
  align-items: center;
  justify-content: center;
  @media (max-width: 520px) {
    grid-column: span 3;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: fit-content;
  width: 100%;
`;

export default class PricingSectionThree extends React.Component<any, any> {
  render() {
    return (
      <SectionOne>
        <GridContainer>
          <GridLeft>
            <GridTitle>
              {this.props?.messages?.PricingPageMoreThan1000Device}
            </GridTitle>
            <GridSubTitle
              id="pricing_talk_to_product_team"
              onClick={() =>
                navigate(
                  this.props.messages?.locale !== 'en'
                    ? `/${this.props.messages?.locale}/book-demo`
                    : '/book-demo'
                )
              }
            >
              {this.props?.messages?.PricingPageTalkToProductTeam}
            </GridSubTitle>
          </GridLeft>
          <GridRight>
            <StyledImg src={card1} />
          </GridRight>
        </GridContainer>
        <GridContainer>
          <GridRight>
            <StyledImg src={card2} />
          </GridRight>
          <GridLeft>
            <GridTitle>
              {this.props?.messages?.PricingPageCustomizedDevice}
            </GridTitle>
            <GridSubTitleSecond
              style={{ color: '#735dbe' }}
              id="pricing_contact_us"
              onClick={() =>
                navigate(
                  this.props.messages?.locale !== 'en'
                    ? `/${this.props.messages?.locale}/contact-us`
                    : '/contact-us'
                )
              }
            >
              {this.props?.messages?.PricingPageContactUs}
            </GridSubTitleSecond>
          </GridLeft>
        </GridContainer>
      </SectionOne>
    );
  }
}
